import {defineStore} from 'pinia'


export const useSettingsManager = defineStore('settings', {
    state: () => ({
        'event': {},
        limits: {},
        settings: {},
        fieldLimits: {},
    }),
    actions: {
        initialize({settings, core, fieldLimits}) {
            this.event = core?.event || {};
            this.limits = core?.limits || {};
            this.settings = settings || {};
            this.fieldLimits = fieldLimits || {};
        },
    }

})
